import { useTheme } from 'styled-components'
import Button from 'mixtiles-web-common/ui/Button'

function ExpressCheckoutLoadingButton() {
  const theme = useTheme()
  return (
    <Button
      fullWidth
      minWidth={0}
      disabled
      backgroundColor={theme.colors.grayDark}
      loading
    />
  )
}

export default ExpressCheckoutLoadingButton
